import pluralize from 'pluralize'
import {SessionFeedbackButtons} from './feedback/SessionFeedbackButtons'
import styles from './SessionFooter.module.css'

interface SessionFooterProps {
  showFeedbackButtons: boolean
  numberOfPremiumRequests: number
  model?: string
}

export function SessionFooter({showFeedbackButtons, numberOfPremiumRequests, model}: SessionFooterProps) {
  return (
    <div className={styles.footer}>
      {showFeedbackButtons && <SessionFeedbackButtons />}
      <div className={styles.metadata}>
        <span>
          {numberOfPremiumRequests} premium {pluralize('request', numberOfPremiumRequests)}
        </span>
        <span>{model && <span className={styles.separator}> · {model}</span>}</span>
      </div>
    </div>
  )
}
